import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { TrustBar } from './components/TrustBar';
import { Services } from './components/Services';
import { WorkGallery } from './components/WorkGallery';
import { Process } from './components/Process';
import { WhyEpic } from './components/WhyEpic';
import { Testimonials } from './components/Testimonials';
import { ServiceArea } from './components/ServiceArea';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-travertine font-sans selection:bg-teal selection:text-white" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <TrustBar data-id="element-4" />
        <Services data-id="element-5" />
        <WorkGallery data-id="element-6" />
        <Process data-id="element-7" />
        <WhyEpic data-id="element-8" />
        <Testimonials data-id="element-9" />
        <ServiceArea data-id="element-10" />
        <Contact data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
    </div>;
}